import { BaseModel } from './base-model.model';

export class ConsultaIPDJSON extends BaseModel {
    public sistema!:string;
    public evento!:string;
	public numeroItemSistemaOrigem!:string;
	public dataBase!:string;
    public horaBase!:string;
	public usuarioIEW!:string;
	public descricao!:string;
	public url!:string;
    public entidadesPapeis!:EntidadePapelJSON[];
}

export class EntidadePapelJSON {

	public identificador!:number;
	public cnpj!:string;
	public cpf!:string;
	public identificadorEntidade!:number;
	public identificadorPessoa!: number;
	public razaoSocial!:string;
	public nomePapel!:string;
	public identificadorPapel!:number;
	public indicadorProdutorRural!:string;
	public faturamentoDeclarado!:string;

}

export const loteCertidaoCADIN =`{"cnpj": ["04431277000120"]}`;
